import React from 'react';
import { Backdrop, CircularProgress, Typography } from '@material-ui/core';
import useStyles from '../../../styles';

export default function LoadingBackdrop(props) {
    const classes = useStyles();

    return (
        <Backdrop {...props} className={classes.loadingBackdrop}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
                <CircularProgress color="inherit" />

            </div>
        </Backdrop>
    );
}